import styled, { css } from 'styled-components';

import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

export const maxWidthCustom = '1140px';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    @media screen and (min-width: ${dsTokens.breakpoint.lg
        .minWidth}) and (max-width: ${maxWidthCustom}) {
      fuel-button::part(button) {
        min-width: auto;
        text-wrap: wrap;
        padding: 0px ${theme.padding.km3};
      }
    }
  `}
`;
